import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import { Input, Label } from "reactstrap";
import { FormGroup } from "@material-ui/core";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmModal({ text, header, onCancel, onAction, open, extraProps = null, showNameInput = false, onNameEdit }) {
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        style={{ zIndex: 1000000 }}
        onClose={onCancel}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {" "}
          <SystemLabel name="AreYouSure" />
        </DialogTitle>
        <DialogContent style={{ width: "350px" }}>
          <DialogContentText component="div" id="alert-dialog-slide-description">
            <SystemLabel name={text} />
            {showNameInput ? (
              <div>
                <br />
                <FormGroup>
                  <Label>
                    <SystemLabel name="NewName" />
                  </Label>
                  <Input type="text" onChange={(e) => onNameEdit(e.target.value)} />
                </FormGroup>
              </div>
            ) : null}
            {/*       <SystemLabel name={text} /> */}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button style={{ cursor: "pointer" }} onClick={onCancel} color="primary">
            <SystemLabel name="ConfirmModalClose" />
          </Button>
          <Button style={{ cursor: "pointer" }} onClick={onAction} color="primary">
            <SystemLabel name="ConfirmModalAgree" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
